import Vue from "vue";
import {
  Layout,
  Button,
  Radio,
  Dropdown,
  Popover,
  Menu,
  Drawer,
  Tabs,
  Tag,
  Icon,
  Modal,
  ConfigProvider,
  AutoComplete,
  Input,
  Select,
  CascaderTable,
  Spin,
  Pagination,
  Message,
  Form,
  Table,
  Tooltip
} from "ways-ui-vue";

Vue.use(Layout);
Vue.use(Button);
Vue.use(Radio);
Vue.use(Dropdown);
Vue.use(Popover);
Vue.use(Menu);
Vue.use(Drawer);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Icon);
Vue.use(Modal);
Vue.use(ConfigProvider);
Vue.use(AutoComplete);
Vue.use(Input);
Vue.use(Select);
Vue.use(CascaderTable);
Vue.use(Spin);
Vue.use(Pagination);
Vue.use(Form);
Vue.use(Table);
Vue.use(Tooltip);

Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$destroyAll = Modal.destroyAll;
Vue.prototype.$message2 = Message;
